module.exports = __webpack_public_path__ + "img/buddy_nose-06.84c81b4b.svg";